/* global WP_DOMAIN, $, _ */

const PAGE_UPDATED = (state, page) => {
  let singleNew = {
    [page.slug]: {
      body: page.content,
    },
  }
  _.assign(singleNew, state.single)
  state.single = singleNew
}

const PAGE_STATIC_UPDATED = (state, page) => {
  let content = page.content || ''
  if (typeof WP_DOMAIN !== 'undefined') {
    content = content.replace(new RegExp('@@wpDomain', 'g'), WP_DOMAIN)
  }
  let singleNew = {
    [page.slug]: content,
  }
  _.assign(singleNew, state.singleStatic)
  state.singleStatic = singleNew
}

const PAGE_API_UPDATED = (state, page) => {
  let singleNew = {}
  let content = page.content || ''
  singleNew = {
    [page.slug.key]: content,
  }
  _.assign(singleNew, state.singleAPI)
  state.singleAPI = singleNew
}

export { PAGE_UPDATED, PAGE_STATIC_UPDATED, PAGE_API_UPDATED }
